<template>
    <main>
        <div class="row mt-2">
            <div class="list-group mb-3 col-lg-4 col-md-12 col-sm-12" v-for="(item) in $v.examenes.$each.$iter" :key="item.id">
                <div class="list-group-item">
                    <div class="d-flex align-items-center justify-content-between">
                        <buttonsCheck 
                            :antecedente="item.$model" 
                            :label="item.$model.descripcion" 
                            :type="item.$model.tipo_campo.codigo"
                            :validator="item"
                            v-model="item.$model.examen.valor">
                        </buttonsCheck>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import buttonsCheck from '../baseButtonsCkeck/indexButtonsNoOptions';
import examenGenitalAnalService from '../../../../services/examenGenitalAnalService';
import examenGenitalAnalUsuarioService from '../../../../services/examenGenitalAnalUsuarioService';
import {required} from "vuelidate/lib/validators";
import { isEmpty } from 'lodash';
import Toast from '../../../../components/common/utilities/toast';
export default {
    props: ['embarazo_actual', 'usuario', 'idHistoria', 'finalizada', 'modo'],
    components: { buttonsCheck },
    data() {
        return {
            type: 'store',
            examenes: []
        }
    },
    validations(){
        return {
            examenes:{
                $each:{
                    examen:{
                        valor:{required}
                    },
                }
            }
        }
    },
    methods:{
        async save() {
            try {
                this.$v.$touch();
                if(this.$v.$invalid){
                    return;
                }

                let examenes_usuario = [];

                this.examenes.forEach((x) => {
                    if (x.examen.valor !== "") {
                        examenes_usuario.push({ ...x.examen });
                    }
                });

                this.LoaderSpinnerShow();
                await examenGenitalAnalUsuarioService.store({
                    examenes_usuario: examenes_usuario,
                });
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: 'success',
                    title: 'Datos guardados con éxito'
                });
            } catch (error) {
                this.LoaderSpinnerHide();
                console.log(error);
                Toast.fire({
                    icon: 'error',
                    title: 'Ha ocurrido un error al procesar la solicitud'
                });
            }
        },
    },
    async created() {
        const filter = {
            sexo: this.usuario.sexo,
            fecha_nacimiento: this.usuario.fecha_nacimiento,
            ...(!isEmpty(this.embarazo_actual) && this.embarazo_actual.activo === 'S' ? { gestante: 'S' } : {})
        };

        const response = await examenGenitalAnalService.index({
            params: filter
        });

        const examenes_usuario = await examenGenitalAnalUsuarioService.index(
            this.idHistoria
        ); 

        this.examenes = response.data.map((y) => {
            const indice = examenes_usuario.data.findIndex(
                (a) => a.id_examen_genital === y.id
            );
            y.examen = {
                id: indice !== -1 ? examenes_usuario.data[indice].id : 0,
                id_usuario: this.usuario.id,
                id_examen_genital: y.id,
                id_historia: this.idHistoria,
                valor: indice !== -1 ? examenes_usuario.data[indice].valor : "",
            };
            return y;
        }); 
    }

}
</script>